import PartGoodReceiptCase from '@/models/PartGoodReceipt/PartGoodReceiptCase';

export default class PartGoodReceiptCaseFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.partGoodReceiptId  = '';
		this.partGoodReceiptPurchaseOrder = '';
		this.purchaseOrderDetailId  = '';
		this.purchaseOrderDetailQtyPo = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.supplierCaseNumber = '';
		this.controlCardId  = '';
		this.controlCardControlCardNumber = '';
		this.qtyReceive = '';
		this.qtyAdjustment = '';
		this.qtyActual = '';
		this.remarkMultiple = '';
		this.partGoodReceiptDetailId  = '';
		this.partGoodReceiptDetailPart = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			partGoodReceiptId : '0',
			partGoodReceiptPurchaseOrder : '0',
			purchaseOrderDetailId : '0',
			purchaseOrderDetailQtyPo : '0',
			partId : '0',
			partPartNumber : '0',
			supplierCaseNumber : '0',
			controlCardId : '0',
			controlCardControlCardNumber : '0',
			qtyReceive : '0',
			qtyAdjustment : '0',
			qtyActual : '0',
			remarkMultiple : '0',
			partGoodReceiptDetailId : '0',
			partGoodReceiptDetailPart : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}